import { fromJS } from 'immutable';
import { Component } from 'react';
import AsyncData from 'conversations-async-data/async-data/AsyncData';
import { requestStarted } from 'conversations-async-data/async-data/operators/requestStarted';
import { requestFailed } from 'conversations-async-data/async-data/operators/requestFailed';
import { requestSucceededWithOperator } from 'conversations-async-data/async-data/operators/requestSucceededWithOperator';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { isLoading, isFailed, isSucceeded } from 'conversations-async-data/async-data/operators/statusComparators';
import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UISelect from 'UIComponents/input/UISelect';
import H2 from 'UIComponents/elements/headings/H2';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { fetchAdminUsers } from '../clients/fetchAdminUsers';
import { mapUsersToOptions } from '../../sales-users/operators/mapUsersToOptions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class RequestAccessToInboxPrompt extends Component {
  constructor(props) {
    super(props);
    this.handleSetAdminToEmail = ({
      target: {
        value
      }
    }) => {
      this.setState({
        selectedAdminId: value
      });
    };
    this.sendEmail = () => {
      this.props.sendRequestAccessToInboxEmail({
        currentInboxId: this.props.currentInboxId,
        lastAccessedInboxId: this.props.lastAccessedInboxId,
        adminId: this.state.selectedAdminId
      });
      this.props.onConfirm();
    };
    this.state = {
      selectedAdminId: null,
      // @ts-expect-error ts-migrate(2348) FIXME: Value of type 'new <AsyncDataValue>(t?: Partial<As... Remove this comment to see the full error message
      asyncAdminUsers: AsyncData()
    };
  }
  componentDidMount() {
    this.setState(({
      asyncAdminUsers
    }) => ({
      asyncAdminUsers: requestStarted(asyncAdminUsers)
    }));
    fetchAdminUsers().then(adminUsersArray => {
      const adminUsers = fromJS(adminUsersArray);
      this.setState(({
        asyncAdminUsers
      }) => ({
        asyncAdminUsers: requestSucceededWithOperator(() => mapUsersToOptions(adminUsers), asyncAdminUsers)
      }));
    }).catch(error => {
      reportError({
        error,
        tags: {
          isVisibleToUser: true
        }
      });
      this.setState(({
        asyncAdminUsers
      }) => ({
        asyncAdminUsers: requestFailed(asyncAdminUsers)
      }));
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
  renderSelect() {
    const options = getData(this.state.asyncAdminUsers);
    return /*#__PURE__*/_jsx(UISelect, {
      className: "m-top-4",
      defaultValue: this.state.selectedAdminId
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      options: options,
      onChange: evt => this.handleSetAdminToEmail(evt),
      placeholder: I18n.text('conversations-inbox-ui.requestAccessToInboxPrompt.placeholder')
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(UIModal, {
      children: [/*#__PURE__*/_jsx(UIDialogHeader, {
        children: /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.requestAccessToInboxPrompt.title"
          })
        })
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.requestAccessToInboxPrompt.body"
        }), isLoading(this.state.asyncAdminUsers) && /*#__PURE__*/_jsx(UILoadingSpinner, {}), isSucceeded(this.state.asyncAdminUsers) && this.renderSelect(), isFailed(this.state.asyncAdminUsers) && /*#__PURE__*/_jsxs(UIErrorMessage, {
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.fatalError.refreshThePage"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.fatalError.contactSupport"
          })]
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: this.sendEmail,
          disabled: this.state.selectedAdminId === null,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.requestAccessToInboxPrompt.confirm"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "secondary",
          onClick: this.props.onReject,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.requestAccessToInboxPrompt.cancel"
          })
        })]
      })]
    });
  }
}
RequestAccessToInboxPrompt.displayName = 'RequestAccessToInboxPrompt';